import React, { memo, useMemo } from 'react'
import classNames from 'classnames'
import { Button, Svg } from '../..'
import * as styles from './styles.module.scss'
import { capitalize } from '../../../../utils/functions'

const TableActionButton = ({
   variant,
   isActive = false,
   onClick,
}: TableActionButtonProps) => {
   const buttonClassName = useMemo(
      () =>
         classNames(styles.actionButton, {
            [styles.actionButtonActive]: isActive,
         }),
      [isActive]
   )

   const iconClassName = useMemo(
      () =>
         classNames(styles.actionButtonIcon, {
            [styles.actionButtonIconActive]: isActive,
         }),
      [isActive]
   )

   const icon = useMemo(() => {
      const width = variant === 'filters' ? 21 : variant === 'sort' ? 19 : 16
      return <Svg id={variant} height={16} width={width} />
   }, [variant])

   const label = useMemo(() => capitalize(variant), [variant])

   return (
      <Button
         type="button"
         className={buttonClassName}
         variant="plain"
         preserveText
         onClick={onClick}
         minWidth="auto"
      >
         <span className={iconClassName}>{icon}</span>
         <span>{label}</span>
      </Button>
   )
}

export default memo(TableActionButton)
